import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const LanguageSelector: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [language, setLanguage] = useState<"Eng" | "हिंदी">("Eng");

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (selectedLang?: "Eng" | "हिंदी") => {
    if (selectedLang) {
      setLanguage(selectedLang);
    }
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        sx={{
          color: "#fff",
          textTransform: "none",
          fontSize: "14px",
        }}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {language}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        PaperProps={{
          sx: {
            width: "120px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right", // 👈 align to button right
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right", // 👈 align to button right
        }}
      >
        <MenuItem onClick={() => handleClose("Eng")}>Eng</MenuItem>
        <MenuItem onClick={() => handleClose("हिंदी")}>हिंदी</MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSelector;
